import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { 
  DocumentReference, ServiceYearMember, SportLeague, SportTeam 
} from 'src/core/models';
import {
  AgeGroupService, ArrayService, AuthService, ChurchService, DatabaseService, 
  EmailService, 
  LeagueService, ServiceYearMemberService, SportTeamService, FestivalUserService
} from 'src/core/services';
import { Observable } from 'rxjs';
import { NgForm } from '@angular/forms';
import { Gender, Sport } from 'src/core/enums';
import { ModalController, AlertController } from '@ionic/angular';
import { PageClass } from 'src/core/classes/page';
import { faTemperatureLow } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-add-team',
  templateUrl: './add-team.component.html',
  styleUrls: ['./add-team.component.less', '../../core/styles/common.less']
})

export class AddTeamComponent extends PageClass implements OnInit {

  sportTeam: any = {
    isActive : true,
    isDeleted : false
  };

  sportTeamList: SportTeam[];
  approverList: DocumentReference[] = [];
  currentLeague: SportLeague;
  leagueList: SportLeague [];
  leagueRefList: DocumentReference [];
  serviceYearMembers: DocumentReference[] = [];
  AllServiceYearMembers: ServiceYearMember[];
  areMembersAccepted: boolean = true;

  serviceYearMembers$: Observable<ServiceYearMember[]>;

  sportList: any[];

  rules: string;

  @Input() churchList: DocumentReference[];
  @Input() ageGroupList: DocumentReference[];

  @ViewChild('addTeamForm', null) addTeamForm: NgForm;

  constructor(
    protected ageGroupService: AgeGroupService,
    protected arrayService: ArrayService,
    protected authService: AuthService,
    protected churchService: ChurchService,
    protected databaseService: DatabaseService,
    protected emailService: EmailService,
    private leagueService: LeagueService,
    private serviceYearMemberService: ServiceYearMemberService,
    private sportTeamService: SportTeamService,
    protected festivalUserService: FestivalUserService,
    private modalController: ModalController,
    private alertController: AlertController
  ) { 
    super(
      ageGroupService, arrayService, authService, 
      churchService, databaseService, festivalUserService
    );
  }

  protected loadData = async () => {
    this.serviceYearMembers = [];

    if (this.currentUser.isActive && !this.currentUser.isDeleted) {
      if (this.churchList && this.churchList.length === 1) {
        this.sportTeam.church = this.churchList[0];
        this.getApprovers();
      } else {
        this.sportTeam.church = null;
      }
      this.sportList = this.currentUser.isAdmin ? this.sportTeamService.getSportList() : this.currentUser.sportList;
    }
  }

  public async populateLeagueList() {
    this.leagueRefList = [];
    this.leagueService.getLeagueList(this.sportTeam.sport).subscribe(leagues => {
        this.leagueList = leagues;
        leagues.forEach(league => {
              this.leagueRefList.push(
                {
                    reference: this.databaseService.doc(`sportLeagues/${league.id}`).ref,
                    displayName: league.displayName
                }
            );
        });

        this.sportTeam.league = null;
    });

    this.getSportLeagueList();
  }

  public async addSportTeam(status: boolean) {
    this.getSportLeagueList();

    if (this.addTeamForm.invalid ||
        (this.currentLeague && this.sportTeamList && this.sportTeamList.length >= this.currentLeague.maxTeams)) {
        this.presentTeamCreationError();
        return;
    }

    if (status && this.sportTeam.isApproved) {
      this.sportTeam.status = 'Approved';
    } else if (status) {
      this.sportTeam.status = 'Submitted';
    } else {
      this.sportTeam.status = 'Saved';
    }

    this.sportTeam.createdBy = this.currentUser.user;
    this.sportTeam.createdAt = new Date().getTime();
    this.sportTeam.updatedBy = this.currentUser.user;
    this.sportTeam.updatedAt = new Date().getTime();
    this.sportTeam.sportName = Sport[this.sportTeam.sport];

    this.sportTeam.id = await this.sportTeamService.createSportTeam(this.sportTeam);
    await this.emailService.sendSportTeamEmail(this.sportTeam);

    this.rules = null;
    this.serviceYearMembers = [];
    this.loadData();

    alert('Team Successfully Created');

    this.dismissModal();
  }

  public async getApprovers() {
    this.approverList = [];
    (await this.festivalUserService.getApprovers(this.sportTeam.church))
      .subscribe(approverList => {
        approverList.forEach(approver => {
            this.approverList.push(
                {
                    reference: this.databaseService.doc(`${this.festivalUserService.collection}/${approver.id}`).ref,
                    displayName: approver.user.displayName
                }
            );
            this.sportTeam.approver = null;
        });
        this.sportTeam.approver = null;
      });

    this.getSportLeagueList();
  }
  
  public leagueChanged() {
    if (this.sportTeam.league == null)
      return;
    
    this.currentLeague = this.leagueList.find(l => l.id === this.sportTeam.league.reference.id);

    if (new Date(this.currentLeague.openDate) > this.today || this.isPastDate(this.currentLeague.closeDate))
    {
        this.showLeagueCreationError();
    }

    this.rules = `<li> Church can have max of ${this.currentLeague.maxTeams} team(s).</li>`;
    this.rules += `<li> Team must be ${this.currentLeague.minMembers} and ${this.currentLeague.maxMembers} player(s).</li>`;
    if (this.currentLeague.minFemale > 0) {
      this.rules += `<li> Team must include ${this.currentLeague.minFemale} female player(s).</li>`;
    }
    if (this.currentLeague.maxMale > 0) {
      this.rules += `<li> Team cannot include more than ${this.currentLeague.maxMale} male player(s).</li>`;
    }

    this.getSportLeagueList();
    this.getMemberGroupList();
  }

  private getMemberGroupList() {
    if (!this.sportTeam.church || !this.sportTeam.sport || !this.sportTeam.league) {
      return;
    }

    this.serviceYearMembers = [];
    this.sportTeam.memberList = [];

    const leagueGender = this.currentLeague.gender;

    if (!!leagueGender) {
      this.serviceYearMembers$ = this.serviceYearMemberService.getTeamMembersYearLevelsByGender(
        this.sportTeam.church, this.currentLeague.yearLevelList, leagueGender);
    } else {
      this.serviceYearMembers$ = this.serviceYearMemberService.getTeamMembersYearLevels(
        this.sportTeam.church, this.currentLeague.yearLevelList);
    }

    this.serviceYearMembers$.subscribe(serviceYearMembers => {
      this.AllServiceYearMembers = serviceYearMembers;
      this.serviceYearMembers = [];
      serviceYearMembers.map(a => this.serviceYearMembers.push({
        displayName: `${a.member.displayName} - ${a.yearLevel.displayName} - ${a.gender.name}`, 
        reference: this.databaseService.doc(`${this.serviceYearMemberService.collection}/${a.id}`).ref
      }));

      this.serviceYearMembers.sort(this.arrayService.orderByDisplayName);
    });
  }

  public canSubmit(): boolean {
    if (this.currentUser.isChurchApprover && !this.sportTeam.isApproved) {
      return false;
    }

    if (!this.areMembersAccepted)
      return false

    if ( !this.sportTeam.memberList ||
         this.sportTeam.memberList.length < this.currentLeague.minMembers ||
         this.sportTeam.memberList.length > this.currentLeague.maxMembers ) {
        return false;
    }

    if ( this.currentLeague.isMixedGender) {
      let femaleMemberCount = 0;
      let maleMemberCount = 0;

      this.sportTeam.memberList.map( a => {
        // tslint:disable-next-line: ban-types
        const memberGender = this.AllServiceYearMembers.find( m => m.id === a.reference.id).gender.value;
        if (memberGender === Gender.Female) {
          femaleMemberCount++;
        } else {
          maleMemberCount++;
        }
      });

      if (femaleMemberCount < this.currentLeague.minFemale || maleMemberCount > this.currentLeague.maxMale) {
        return false;
      }
    }

    return true;
  }

  private getSportLeagueList() {

    if (this.sportTeam && this.sportTeam.church && this.sportTeam.sport && this.sportTeam.league) {
      const sportTeamList$: Observable<SportTeam[]> = this.sportTeamService.getSportLeagueTeams(
        this.sportTeam.church,
        this.sportTeam.sport,
        this.sportTeam.league
      );

      sportTeamList$
        .subscribe(sportTeamList => {
          this.sportTeamList = sportTeamList;
        });
    }
  }

  public presentTeamCreationError = async () => {

    if (this.currentLeague && this.sportTeamList && this.sportTeamList.length >= this.currentLeague.maxTeams) {

      const alert = await this.alertController.create({
        header: 'Cannot Create Team',
        message: this.rules,
        buttons: ['OK'],
      });

      let errorMessage = 'You cannot add new teams for this league as you church already had following teams';

      this.sportTeamList.forEach((team) => {
        errorMessage += `<li>${team.displayName}</li>`;
      });

      await alert.present();
    }
  }

  dismissModal() {
    this.modalController.dismiss();
  }

  presentRules = async () => {
    const rules = await this.alertController.create({
      header: 'Sport Team Rules',
      message: this.rules,
      buttons: ['OK'],
    });

    await rules.present();
  }

  showLeagueCreationError = async () => {
    let errorMessage = new Date(this.currentLeague.openDate) > this.today ? 
      `Sorry you cannot create team for this league until ${new Date(this.currentLeague.openDate).toDateString()}` : 
      `Sorry you cannot create team for this league after ${new Date(this.currentLeague.closeDate).toDateString()}`;

    const alert = await this.alertController.create({
      header: 'Cannot Create Team',
      message: errorMessage,
      buttons: ['OK'],
    });

    alert.onDidDismiss().then(() => { this.sportTeam.league = undefined });

    await alert.present();
  }

  public memberListUpdated = () => {
    if (this.sportTeam.memberList.length === 1) {
      var memberName = this.AllServiceYearMembers.find( m => m.id === this.sportTeam.memberList[0].reference.id).member.displayName;
      this.sportTeam.displayName = memberName;
    }
  
    this.areMembersAccepted = false;
    
    this.sportTeamService.getSportLeagueTeams(this.sportTeam.church, this.sportTeam.sport, this.sportTeam.league)
      .subscribe((leagueTeams) => {

        if (leagueTeams?.length > 0) {
          
          for (var leagueTeam of leagueTeams) {
            if (leagueTeam.id === this.sportTeam.id)
              continue;
              
            var members = leagueTeam.memberList;

            for (var pMember of this.sportTeam.memberList) {

              if (members.find(m => m.reference.id == pMember.reference.id)) {
                this.showErrorMessage(
                  'Cannot Add Member', 
                  `Sorry, you cannot add member ${pMember.displayName}, member is already in another team`);
                return;
              }
            };         
          };
        }

        this.areMembersAccepted = true;
      })
  }

  showErrorMessage = async (header: string, errorMessage: string) => {
    const alert = await this.alertController.create({
      header: header,
      message: errorMessage,
      buttons: ['OK'],
    });

    await alert.present();
  }
}
